import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Loading } from '/imports/ui/Loading';

interface LoadingFillProps {
  caption?: string;
  className?: string;
}

const LoadingFillStyled = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: ${css.backgroundColor};
  z-index: 100;
  position: absolute;
  ${css.mobileMedia} {
    &.loading-page {
      top: ${css.navHeightMobile};
    }
  }
`;

/**
 * Full-area loading overlay wrapping a centered Loading spinner.
 */
export const LoadingFill = (props: LoadingFillProps) => (
  <LoadingFillStyled className={`loading-fill ${props.className}`}>
    <Loading caption={props.caption} />
  </LoadingFillStyled>
);